// extracted by mini-css-extract-plugin
module.exports = {"panel":"SideLabel_panel__1Br__"};